import { useEffect, useState, type ComponentProps } from 'react';
import type { ShipId } from '../../../game/catalog';
import WindowInterface from './Interface';

type OuterProps = Omit<
  ComponentProps<typeof WindowInterface>,
  'browseId' | 'onBrowse' | 'onConfirm'
> & {
  selectedId: ShipId;
  onSelect: (id: ShipId) => void;
};

/**
 * Browse focus is local until the user confirms USE CRAFT (writes selectedId).
 */
export default function Container(props: OuterProps) {
  const { selectedId, onSelect, ...rest } = props;
  const [browseId, setBrowseId] = useState<ShipId>(selectedId);

  // Keep browse in sync when the window opens with a different equipped craft
  useEffect(() => {
    setBrowseId(selectedId);
  }, [selectedId]);

  return (
    <WindowInterface
      {...rest}
      selectedId={selectedId}
      browseId={browseId}
      onBrowse={setBrowseId}
      onConfirm={() => onSelect(browseId)}
    />
  );
}
